export const VERSION = "v4.47.0";
